import { PaymentMethod } from '@/enums/payment-types.enum';
import { ICreditCardDetails, IDirectDebitBankAccountDetails } from '../make-a-payment/make-a-payment.interface';

export interface ApttusDirectDebitStatusResponse {
  status: ApttusDirectDebitStatus;
  paymentMethodId: string;
  paymentMethod: PaymentMethod;
  creditCard?: ICreditCardDetails;
  bank?: IDirectDebitBankAccountDetails;
}

export enum ApttusDirectDebitStatus {
  NotFound,
  Current,
}
